(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novapep-explore-range"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('novapep-range-tabs')) {
    class NovapepRangeTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.cleanup = [];
        this.tabs.forEach((tab) => {
          const click = () => this.activate(tab);
          const keydown = (event) => this.onKeydown(event);
          tab.addEventListener('click', click);
          tab.addEventListener('keydown', keydown);
          this.cleanup.push(() => tab.removeEventListener('click', click));
          this.cleanup.push(() => tab.removeEventListener('keydown', keydown));
        });
        this.querySelectorAll('[data-panel]').forEach((panel) => this.setupCarousel(panel));
        this.blockSelect = (event) => {
          const tab = this.querySelector(`[data-block-id="${CSS.escape(event.detail.blockId)}"]`);
          if (tab) this.activate(tab);
        };
        document.addEventListener('shopify:block:select', this.blockSelect);
        this.resize = () => this.updateActiveCarousel();
        window.addEventListener('resize', this.resize);
        requestAnimationFrame(() => this.updateActiveCarousel());
      }

      disconnectedCallback() {
        this.cleanup.forEach((fn) => fn());
        document.removeEventListener('shopify:block:select', this.blockSelect);
        window.removeEventListener('resize', this.resize);
      }

      panelFor(tab) {
        const id = tab.getAttribute('aria-controls');
        return id ? this.querySelector(`#${CSS.escape(id)}`) : null;
      }

      activate(tab, focus = false) {
        this.tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.setAttribute('tabindex', selected ? '0' : '-1');
          const panel = this.panelFor(item);
          if (panel) panel.hidden = !selected;
        });
        if (focus) tab.focus();
        requestAnimationFrame(() => this.updateActiveCarousel());
      }

      onKeydown(event) {
        const index = this.tabs.indexOf(event.currentTarget);
        if (index < 0) return;
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(this.tabs[nextIndex], true);
      }

      setupCarousel(panel) {
        const track = panel.querySelector('[data-track]');
        const previous = panel.querySelector('[data-previous]');
        const next = panel.querySelector('[data-next]');
        if (!track || !previous || !next) return;
        const update = () => this.updateCarousel(panel);
        const previousClick = () => this.move(track, -1);
        const nextClick = () => this.move(track, 1);
        track.addEventListener('scroll', update, { passive: true });
        previous.addEventListener('click', previousClick);
        next.addEventListener('click', nextClick);
        this.cleanup.push(() => track.removeEventListener('scroll', update));
        this.cleanup.push(() => previous.removeEventListener('click', previousClick));
        this.cleanup.push(() => next.removeEventListener('click', nextClick));
      }

      move(track, direction) {
        const slide = track.querySelector('.npr__slide');
        const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
        const distance = slide ? slide.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      }

      updateActiveCarousel() {
        const panel = this.querySelector('[data-panel]:not([hidden])');
        if (panel) this.updateCarousel(panel);
      }

      updateCarousel(panel) {
        const track = panel.querySelector('[data-track]');
        const previous = panel.querySelector('[data-previous]');
        const next = panel.querySelector('[data-next]');
        const progressbar = panel.querySelector('[data-progressbar]');
        const progress = panel.querySelector('[data-progress]');
        if (!track || !previous || !next || !progressbar || !progress) return;
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const current = Math.max(0, track.scrollLeft);
        const percentage = track.scrollWidth > 0 ? Math.min(100, ((current + track.clientWidth) / track.scrollWidth) * 100) : 100;
        previous.disabled = current <= 2;
        next.disabled = maximum <= 2 || current >= maximum - 2;
        progress.style.transform = `scaleX(${percentage / 100})`;
        progressbar.setAttribute('aria-valuenow', String(Math.round(percentage)));
      }
    }

    customElements.define('novapep-range-tabs', NovapepRangeTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
